import { useEffect } from "react";

import { env } from "@/config";
import { FEATURE } from "@/features";
import { useOrganization } from "@/hooks/useOrganization";
import { useUser } from "@/hooks/useUser";
import Intercom, {
  show,
  showArticle,
  startSurvey,
} from "@intercom/messenger-js-sdk";

import { useHasFeature } from "./useHasFeature";

export const useIntercom = () => {
  const { data: userData } = useUser();
  const user = userData?.ok ? userData.data : null;
  const { data: orgData } = useOrganization();
  const organization = orgData?.ok ? orgData.data : null;
  const hasSearch = useHasFeature(FEATURE.HAS_SEARCH_PRODUCT);
  const hasMonitoring = useHasFeature(FEATURE.HAS_MEDIA_MONITORING_PRODUCT);
  const disabled = !user || !organization || env !== "production";

  useEffect(() => {
    if (disabled) return;
    Intercom({
      app_id: "zlt4hanz",
      horizontal_padding: 24, // 1.5rem
      vertical_padding: 24,
      name: user.name,
      email: user.email,
      language_override: user.language,
      custom_attributes: {
        type: user.user_type,
      },
      company: {
        id: organization.id,
        name: organization.name,
        plan: organization.status,
        has_product_search: hasSearch,
        has_product_monitoring: hasMonitoring,
      },
      user_id: `${user.id}`,
    });
  }, [disabled, organization, user, hasSearch, hasMonitoring]);

  if (disabled) return {};

  return { show, showArticle, startSurvey };
};
